import Vue from 'vue'
import Router from 'vue-router'
import Landing from '../views/landing.vue'
import Cooperate from '../views/cooperate.vue'
import PCCommon from '../views/common/PC.vue'
import H5Common from '../views/common/H5.vue'
import Extension from '../views/extension/PC.vue'
import Semtest from '../views/semtest/PC.vue'
import Bankeys from './bankeys'
import Package from './purchase'
import MultiVersionH5 from '../views/multiVersionH5.vue'
import RealEstate from '../views/real-estate/index.vue'
// import mixOsPC from '../views/mixOs/PC.vue'
// import mixOsH5 from '../views/mixOs/H5.vue'
import { isClient } from '@/lib/utils' // 11
import Semtel from '../views/extension/semtel.vue'
import Comnav from '../views/common/comnav.vue'
Vue.use(Router)

let isPhone = false
try {
  // isPhone = document.documentElement.clientWidth <= 766
  isPhone = isClient()
} catch (e) {
  isPhone = false
}

const router = new Router({
  base: '/',
  mode: 'history',
  fallback: false,
  routes: [
    {
      path: '/landing',
      name: 'home',
      component: Landing, // () => import(/* webpackChunkName: "landing" */'landing.vue'),
      redirect: '/landing/cooperate',
      children: [
        {
          path: 'cooperate',
          name: 'cooperate',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited./* webpackChunkName: "about" */
          component: Cooperate, // () => import(/* webpackChunkName: "landing" */ './views/cooperate.vue')
        },
      ],
    },
    {
      path: '/landing/common',
      name: 'common-landing-page',
      component: isPhone ? H5Common : PCCommon,
    },
    // 修改/landing/common带导航
    {
      path: '/landing/comnav',
      name: 'common-landing-comnav',
      component: isPhone ? H5Common : Comnav,
    },
    {
      path: '/landing/multiVersion',
      name: 'landing-multi-version',
      component: MultiVersionH5,
    },
    {
      path: '/landing/realEstate',
      name: 'landing-real-estate',
      component: RealEstate,
    },
    // 推广页(不带导航版)
    {
      path: '/sempc',
      name: 'sempc',
      component: isPhone ? H5Common : Extension,
    },
    // 20221011迭代，新页面
    {
      path: '/landing/semtest',
      name: 'semtest',
      component: isPhone ? H5Common : Semtest,
    },
    // 推广页(带导航版)
    {
      path: '/semnav',
      name: 'semnav',
      component: isPhone ? H5Common : Extension,
    },
    //  修改页面
    {
      path: '/landing/semtel',
      name: 'semtel',
      component: isPhone ? H5Common : Semtel,
    },
    // 春生计划(20220428 原因:活动下线)
    // {
    //   path: '/chunsheng',
    //   name: 'chunsheng',
    //   component: isPhone ? H5Common : Extension,
    // },
    // 混合云产品落地页(20220426暂时下线 原因:整改)
    {
      path: '/landing/mixOs',
      name: 'mixOs',
      meta: {
        title: '天印电子签章系统 - e签宝',
      },
      component: isPhone
        ? resolve => {
            require(['../views/mixOs/H5.vue'], resolve)
          }
        : resolve => {
            require(['../views/mixOs/PC.vue'], resolve)
          },
    },
    // OFD电子保函解决方案页面
    {
      path: '/landing/ofd',
      name: 'ofd',
      meta: {
        title: 'OFD电子保函解决方案 - 电子签章 - e签宝电子签名',
      },
      component: isPhone
        ? resolve => {
            require(['../views/ofd/H5.vue'], resolve)
          }
        : resolve => {
            require(['../views/ofd/PC.vue'], resolve)
          },
    },
    // 思格特印控仪，物理印章管理系统页面
    {
      path: '/landing/signetPrint',
      name: 'signet',
      meta: {
        title: '智能印章管理系统 - e签宝',
      },
      component: isPhone
        ? resolve => {
            require(['../views/signet/H5.vue'], resolve)
          }
        : resolve => {
            require(['../views/signet/PC.vue'], resolve)
          },
    },
    // 智能合同落地页
    {
      path: '/landing/smartContract',
      name: 'smartContract',
      component: () => import('../views/smartContract/PC.vue'),
    },
    // 印章落地页
    {
      path: '/landing/semsign',
      name: 'semsign',
      component: () => import('../views/semsign/PC.vue'),
    },
    // 新增-智能合同落地页（之前智能合同落地页效果不加，故新增）
    {
      path: '/landing/contractmanage',
      name: 'contractmanage',
      component: () => import('../views/contractmanage/PC.vue'),
    },
    // 印控仪&电子签章一体化落地页
    {
      path: '/landing/sealmanage',
      name: 'sealmanage',
      component: () => import('../views/sealmanage/PC.vue'),
    },
    // 电子印章落地页https://www.esign.cn/landing/semsign数据良好，在基础上新增一个电子合同/semcontract和一个电子签章/semsignature版本落地页，需改变几个标题即可。
    {
      path: '/landing/semcontract',
      name: 'semcontract',
      component: () => import('../views/semsign/PC.vue'),
    },
    {
      path: '/landing/semsignature',
      name: 'semsignature',
      component: () => import('../views/semsign/PC.vue'),
    },
    {
      path: '/landing/esignMultiVersion',
      name: 'esignMultiVersion',
      component: () => import('../views/esignMultiVersion.vue'),
    },
    {
      path: '/landing/semsaas',
      name: 'semSaas',
      meta: {
        title: '电子合同SaaS平台 - e签宝',
      },
      component: () => import('../views/semsaas/PC.vue'),
    },
    {
      path: '/landing/sempro',
      name: 'semPro',
      meta: {
        title: '电子合同SaaS平台 - e签宝',
      },
      component: isPhone
        ? resolve => {
            require(['../views/sempro/H5.vue'], resolve)
          }
        : resolve => {
            require(['../views/sempro/PC.vue'], resolve)
          },
    },
    {
      path: '/landing/semapi',
      name: 'semApi',
      meta: {
        title: '电子合同电子签章对接集成 - e签宝',
      },
      component: () => import('../views/semapi/PC.vue'),
    },
    {
      path: '/landing/semlocal',
      name: 'semLocal',
      meta: {
        title: '天印统一电子签章系统本地化部署 - e签宝',
      },
      component: () => import('../views/semlocal/index.vue'),
    },
    {
      path: '/landing/semqa',
      name: 'semQa',
      meta: {
        title: '第三方在线电子合同平台 - e签宝',
      },
      component: () => import('../views/semqa/index.vue'),
    },
    {
      path: '/landing/sem618',
      name: 'sem618',
      meta: {
        title: '电子合同电子签章618优惠活动专区 - e签宝',
      },
      component: isPhone
        ? resolve => {
            require(['../views/sem618/H5.vue'], resolve)
          }
        : resolve => {
            require(['../views/sem618/PC.vue'], resolve)
          },
    },
    {
      path: '/landing/semsignsaas',
      name: 'semsignsaas',
      meta: {
        title: '企业电子公章怎么申请 - e签宝电子签章',
      },
      component: () => import('../views/semsignsaas/index.vue'),
    },
    {
      path: '/landing/semsal',
      name: 'semsal',
      meta: {
        title: '电子合同签订平台 - e签宝',
      },
      component: () => import('../views/semsal/index.vue'),
    },
    ...Bankeys,
    ...Package,
  ],
})

router.beforeEach((to, from, next) => {
  try {
    /**
     * 1、新增二级域名: guangzhou.esign.cn, 这个域名下面只有一个页面，即/sempc
     * 2、基于上一个备注，guangzhou.esign.cn这个域名下多了个新页面，用于分流测试
     * 3、20230216需求：
     *    以【https://www.esign.cn/landing/semsignature】和【/landing/semsign】两个落地页为母版，
     *    新增出两个guangzhou.esign.cn域名的地址
     */
    if (window.location.hostname === 'guangzhou.esign.cn') {
      if (to.path === '/sempc') {
        next()
      } else if (to.path === '/landing/semsignature') {
        next()
      } else if (to.path === '/landing/semsign') {
        next()
      } else if (to.path === '/landing/semtest') {
        next()
      } else {
        next('/sempc')
      }

      return
    }

    next()
  } catch (error) {
    console.log('to:->', to)
  }
})

export default router
